var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V14C22 15.1046 21.1046 16 20 16H14.0833L14.4375 20.25H16C16.4142 20.25 16.75 20.5858 16.75 21C16.75 21.4142 16.4142 21.75 16 21.75H8C7.58579 21.75 7.25 21.4142 7.25 21C7.25 20.5858 7.58579 20.25 8 20.25H9.5625L9.91667 16H4C2.89543 16 2 15.1046 2 14V5ZM12.7 5.5H11.3C11.0239 5.5 10.8 5.72386 10.8 6V8.3H8.5C8.22386 8.3 8 8.52386 8 8.8V10.2C8 10.4761 8.22386 10.7 8.5 10.7H10.8V13C10.8 13.2761 11.0239 13.5 11.3 13.5H12.7C12.9761 13.5 13.2 13.2761 13.2 13V10.7H15.5C15.7761 10.7 16 10.4761 16 10.2V8.8C16 8.52386 15.7761 8.3 15.5 8.3H13.2V6C13.2 5.72386 12.9761 5.5 12.7 5.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopComputer);
export default __webpack_public_path__ + "static/media/desktop-computer.b266e3915cf8797843fbaad551f660c1.svg";
export { ForwardRef as ReactComponent };